<section class="mb-2">
    <div class="card border-color-primary">
        <div class="card-header border-color-primary background-color-primary color-white">
            <div class="row">
                <div class="col text-end">
                    <fa-icon [icon]="icons['faEdit']" class="me-2" placement="top"
                        ngbTooltip="{{'ORGANIZATION.SCHEDULES.edit' | translate}}" (click)="onEditClick()">
                    </fa-icon>
                    <fa-icon [icon]="icons['faTrashAlt']" placement="top"
                        ngbTooltip="{{'ORGANIZATION.SCHEDULES.delete' | translate}}" (click)="onDeleteClick()">
                    </fa-icon>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <ul class="list-group list-group-horizontal">
                    <li class="list-group-item flex-fill">{{schedule.name_it}}</li>
                    <li class="list-group-item flex-fill">{{schedule.name_de}}</li>
                    <li class="list-group-item flex-fill">{{schedule.name_en}}</li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <ul class="list-group list-group-horizontal">
                    <ng-container *ngIf="schedule.fullYear; else notFullYearTemplate">
                        <li class="list-group-item flex-fill">
                            <strong>{{'ORGANIZATION.SCHEDULES.fullYear' | translate}}</strong>
                        </li>
                    </ng-container>
                    <ng-template #notFullYearTemplate>
                        <li class="list-group-item flex-fill">
                            <span>{{'ORGANIZATION.SCHEDULES.startDate' | translate}}</span> <strong>
                                {{schedule.startDate | date:'dd-MM-yyyy'}}</strong>
                        </li>
                        <li class="list-group-item flex-fill">
                            <span>{{'ORGANIZATION.SCHEDULES.endDate' | translate}}</span> <strong>
                                {{schedule.endDate | date:'dd-MM-yyyy'}}</strong>
                        </li>
                    </ng-template>
                </ul>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-sm m-0 border-0 p-1">
                <thead>
                    <tr>
                        <th scope="col">{{'ORGANIZATION.SCHEDULES.openingHour' | translate}}</th>
                        <th scope="col">{{'ORGANIZATION.SCHEDULES.closingHour' | translate}}</th>
                        <!-- <th scope="col">Lunch Time</th> -->
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.mon' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.tue' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.wed' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.thu' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.fri' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.sat' | translate}}</th>
                        <th scope="col" style="width: 7%;">{{'ORGANIZATION.SCHEDULES.sun' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let scheduleTime of schedule.scheduleTime; let i=index">
                        <td class="text-center">{{scheduleTime.openingHour}}</td>
                        <td class="text-center">{{scheduleTime.closingHour}}</td>
                        <!-- <td class="text-center">{{scheduleTime.lunchStartHour}} - {{scheduleTime.lunchEndHour}}</td> -->
                        <td [ngClass]="{'table-success': day === '1'}"
                            *ngFor="let day of scheduleTime.openingDays.split(''); let i=index"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>